<template>
    <div>
        <div id="printContent" class="print-zone">
            <div v-bind:key="item.EntpCusOId" v-for="item in printList">
                <div class="print-title-view">
                    <div class="order-code">
                        <!-- <svg id="barcode" /> -->
                        <canvas id="canvas" class="qrcode-canvas" ref="canva"></canvas>
                        <img class="qrcode-image" :src="imgUrl" v-if="imgUrl" />
                    </div>
                    <div class="print-title">装箱单</div>
                    <div class="order-detail">
                        <div>单号：{{ item.PackingCode }}</div>
                        <div>日期：{{ item.CreateTime }}</div>
                    </div>
                </div>

                <div class="print-table-main">
                    <div class="div-table-row">
                        <div class="div-table-cell" style="width: 20%">客户名称</div>
                        <div class="div-table-cell" style="width: 80%">
                            {{ item.EntpCusName }}
                        </div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell" style="width: 20%">客户地址</div>
                        <div class="div-table-cell" style="width: 80%">
                            {{ item.FullAddress }}
                        </div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell" style="width: 6%">序号</div>
                        <div class="div-table-cell" style="width: 14%">汽配编码</div>
                        <div class="div-table-cell" style="width: 12%">配件名称</div>
                        <div class="div-table-cell" style="width: 10%">车型</div>
                        <div class="div-table-cell" style="width: 6%">数量</div>
                        <div class="div-table-cell" style="width: 5%">单位</div>
                        <div class="div-table-cell" style="width: 10%">箱号</div>
                        <div class="div-table-cell" style="width: 10%">数量/箱</div>
                        <div class="div-table-cell" style="width: 5%">箱数</div>
                        <div class="div-table-cell" style="width: 8%">总个数</div>
                        <div class="div-table-cell" style="width: 7%">总方数</div>
                        <div class="div-table-cell" style="width: 7%">总重量</div>
                    </div>
                    <div class="div-table-row" v-bind:key="index" v-for="(AP, index) in item.DetailList">
                        <div class="div-table-cell" style="width: 6%">
                            {{ AP.SortNum == 0 ? Number(index) + 1 : AP.SortNum }}
                        </div>
                        <div class="div-table-cell" style="width: 14%">{{ AP.APCode }}</div>
                        <div class="div-table-cell" style="width: 12%">
                            {{ AP.GoodName }}
                        </div>
                        <div class="div-table-cell" style="width: 10%">
                            {{ AP.AutoSerise }}
                        </div>
                        <div class="div-table-cell" style="width: 6%">{{ AP.Count }}</div>
                        <div class="div-table-cell" style="width: 5%">{{ AP.Unit }}</div>
                        <div class="div-table-cell" style="width: 10%">
                            {{ AP.PackingNo }}
                        </div>
                        <div class="div-table-cell" style="width: 10%">
                            {{ AP.PCSEach }}
                        </div>
                        <div class="div-table-cell" style="width: 5%">
                            {{ AP.BoxCount }}
                        </div>
                        <div class="div-table-cell" style="width: 8%">
                            {{ AP.PCSEach * (AP.BoxCount ? (AP.BoxCount == 0 ? 1 : AP.BoxCount) : 1) }}
                        </div>
                        <div class="div-table-cell" style="width: 7%">
                            {{ ((AP.Length / 100) * (AP.Width / 100) * (AP.Height / 100) * AP.BoxCount).toFixed(3) }}
                        </div>
                        <div class="div-table-cell" style="width: 7%">
                            {{ (AP.Weight * AP.BoxCount).toFixed(3) }}
                        </div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell" style="width: 6%"></div>
                        <div class="div-table-cell" style="width: 14%"></div>
                        <div class="div-table-cell" style="width: 12%"></div>
                        <div class="div-table-cell" style="width: 10%">总数量</div>
                        <div class="div-table-cell" style="width: 6%">{{ allCount }}</div>
                        <div class="div-table-cell" style="width: 5%"></div>
                        <div class="div-table-cell" style="width: 10%"></div>
                        <div class="div-table-cell" style="width: 10%">合计</div>
                        <div class="div-table-cell" style="width: 5%">{{ totalBox }}</div>
                        <div class="div-table-cell" style="width: 8%">{{ total }}</div>
                        <div class="div-table-cell" style="width: 7%">
                            {{ totalCbm.toFixed(3) }}
                        </div>
                        <div class="div-table-cell" style="width: 7%">
                            {{ totalWeight.toFixed(3) }}
                        </div>
                    </div>
                </div>
                <div class="order-detail">
                    <div>客户要求：{{ item.Remark }}</div>
                </div>
            </div>
        </div>
        <div class="dialog-footer">
            <div class="re-submit">
                <el-button class="btn-primary" @click="printedRecord" v-print="'#printContent'">打印</el-button>
                <el-button @click="cancel()">关闭</el-button>
            </div>
        </div>
    </div>
</template>
<script>
import html2canvas from 'html2canvas';
// import JsBarcode from 'jsbarcode';
import QRCode from 'qrcode';
export default {
    name: '',
    components: {},
    props: ['printIds'],
    data() {
        return {
            allCount: 0, //销售总数
            total: 0, //总个数
            totalBox: 0,
            totalCbm: 0,
            totalWeight: 0,
            printList: [],
            imgUrl: ''
        };
    },
    watch: {
        printList(value) {
            this.$nextTick(function () {
                try {
                    let canvas = this.$refs.canva[0];
                    QRCode.toCanvas(
                        canvas,
                        value[0].PackingCode,
                        {
                            width: 80,
                            height: 80,
                            margin: 0,
                            scrollX: 0,
                            scrollY: 0
                        },
                        function (error) {}
                    );

                    setTimeout(() => {
                        html2canvas(canvas, {
                            width: 80,
                            height: 80,
                            scrollX: 0,
                            scrollY: 0
                        }).then(canvasRes => {
                            var imgData = canvasRes.toDataURL('image/png');
                            this.imgUrl = imgData;
                            canvas.style.display = 'none';
                        });
                    }, 1000);
                } catch (e) {
                    //
                }
            });
        }
    },
    mounted() {
        this.getPackingList();
    },
    methods: {
        printedRecord() {
            this.$util.printedRecord({
                    OrderId: this.printIds[0],
                    Type: 3
                })
                .then(res => {});
        },
        // 取消
        cancel() {
            this.$emit('closeDialog');
        },
        // 获取表格数据
        getPackingList() {
            this.$util
                .axiosGet({
                    url: '/api/EntpPackingList/GetEnterprisePackingListById',
                    data: {
                        PLId: this.printIds[0]
                    }
                })
                .then(res => {
                    let _allCount = 0;
                    let _total = 0;
                    let _totalBox = 0;
                    let _totalCbm = 0;
                    let _totalWeight = 0;
                    let data = res.data;
                    let DetailList = data.DetailList;
                    for (let i = 0; i < DetailList.length; i++) {
                        _allCount += DetailList[i].Count;
                        _total += DetailList[i].PCSEach * (DetailList[i].BoxCount ? (DetailList[i].BoxCount == 0 ? 1 : DetailList[i].BoxCount) : 1);
                        _totalBox += DetailList[i].BoxCount;
                        _totalCbm += (DetailList[i].Length / 100) * (DetailList[i].Width / 100) * (DetailList[i].Height / 100) * DetailList[i].BoxCount;
                        _totalWeight += DetailList[i].Weight * DetailList[i].BoxCount;
                    }
                    this.allCount = _allCount;
                    this.total = _total;
                    this.totalBox = _totalBox;
                    this.totalCbm = _totalCbm;
                    this.totalWeight = _totalWeight;
                    this.printList.push(res.data);
                });
        }
    }
};
</script>
<style lang="less" scoped media="print">
.print-title-view {
    width: 100%;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding: 12px 0;
    .qrcode-canvas,
    .qrcode-image {
        width: 80px;
        height: 80px;
        display: inline-block;
        vertical-align: top;
    }
}
.order-detail {
    color: #000;
}
.order-remark {
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-left: 10px;
    margin-right: 10px;
    padding: 0px 0px 15px 0px;
    color: #000;
}
.order-setcontent {
    padding: 0px 0px 15px 0px;
    color: #000;
}
.print-title {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    font-size: 20px;
    font-weight: bold;
    color: #000;
}
.dialog-footer {
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 20px;
}
.re-submit {
    text-align: right;
}

.print-zone {
    width: 210mm;
    margin-left: 2rpx;
}

.print-table-main {
    width: 792px;
    margin-left: 1px;
    .div-table-cell {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        height: auto;
        line-height: 30px;
        padding-left: 10px;
        border-top: 1px solid #000;
        border-right: 1px solid #000;
        border-bottom: 1px solid #000;
        color: #000;
    }
    .div-table-row {
        border-left: 1px solid #000;
    }
    .pall-count {
        text-align: right;
    }
}
.btn-ctn-left {
    display: flex;
}
</style>
